module.exports = __webpack_public_path__ + "static/media/ng.e752bb6a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ng.svg
// module id = 2174
// module chunks = 0